import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import useCellCopyAction from "../useCellCopyAction";
import { STACKS_COLUMN_ID } from "../constants";

const StacksTableUpdatedAtCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const copyAction = useCellCopyAction({
    column: STACKS_COLUMN_ID.UPDATED_AT,
    text: makeTimestampToCopy(stack.stateSetAt || 0),
  });

  const isEmpty = !stack.stateSetAt;

  const actions = useMemo(() => (isEmpty ? undefined : [copyAction]), [isEmpty, copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}

      {!isEmpty && <Timestamp timestamp={stack.stateSetAt!} />}
    </TableSimpleCell>
  );
};

export default StacksTableUpdatedAtCell;
